export function BookCover({ book, className = "", size = "md" }) {
  const c = book.colors || { bg: "#2a2a2a", ink: "#eee", spine: "#111" };
  const sizes = {
    sm: "text-[10px] p-2",
    md: "text-xs p-3",
    lg: "text-sm p-5",
    xl: "text-base p-8",
  };
  return (
    <div
      className={`bk-cover ${sizes[size] || sizes.md} ${className}`}
      style={{
        background: `linear-gradient(155deg, ${c.bg} 0%, ${c.spine} 100%)`,
        color: c.ink,
      }}
      data-testid={`book-cover-${book.id}`}
    >
      <div className="relative z-[2] h-full flex flex-col justify-between">
        <div>
          <div
            className="tracking-caps font-ui opacity-70"
            style={{ fontSize: "0.55em", letterSpacing: "0.22em" }}
          >
            pagesbyadam
          </div>
          <div className="mt-1 h-px w-8" style={{ background: c.ink, opacity: 0.5 }} />
        </div>

        <div className="font-display leading-[0.95] break-words" style={{ fontSize: "1.35em", fontWeight: 600 }}>
          {book.title}
        </div>

        <div className="flex items-end justify-between">
          <div className="font-ui opacity-80" style={{ fontSize: "0.7em" }}>
            {book.author}
          </div>
          <div className="tracking-caps font-ui opacity-60" style={{ fontSize: "0.55em" }}>
            №{book.id}
          </div>
        </div>
      </div>
    </div>
  );
}
